// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"221":"paragon-theme-core","457":"paragon-theme-variants-light","524":"app"}[chunkId] + "." + {"221":"7078100f00105aa59118","457":"572cbf14cc0176080a11","524":"3754b720e9967eac63c6"}[chunkId] + ".css";
};